// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/FiscalYear.yaml
// Generated: 2026-05-31T11:28:49.286Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateFiscalYear, UpdateFiscalYear, FiscalYear } from '@/types/finance/FiscalYear';

/**
 * FiscalYear Service
 * CRUD operations for FiscalYear via the ABP API.
 */
export const fiscalYearService = new EntityService<FiscalYear, CreateFiscalYear, UpdateFiscalYear>(
  '/api/finance/fiscalyear',
  'FiscalYear',
);
